import React, { useState, useEffect, useRef } from "react";
import "./footer.css";
import { eventClick } from "../services/adobeDataLayer.js";

function Footer() {

  const ctaRef = useRef(null);
  const [showButton, setShowButton] = useState(false);
  const [ctaHeight, setCtaHeight] = useState(0);
  useEffect(() => {
    const handlePosition = () => {
      setShowButton(window.scrollY > 150);
      setCtaHeight(ctaRef.current ? ctaRef.current.offsetHeight : 0);
    };
    handlePosition();

    window.addEventListener("scroll", handlePosition);
    window.addEventListener("resize", handlePosition);

    return () => {
      window.removeEventListener("scroll", handlePosition);
      window.removeEventListener("resize", handlePosition);
    };
  }, []);

  // Re-measure as soon as the CTA mounts, so the spacer below the footer is
  // sized before the user can reach the bottom of the page.
  useEffect(() => {
    setCtaHeight(ctaRef.current ? ctaRef.current.offsetHeight : 0);
  }, [showButton]);

  const handleCTAClick = (e) => {
    e.preventDefault();
    eventClick("apply now", "button", "footer");
    window.dispatchEvent(new CustomEvent("adobeCTAClick"));
    const formElement = document.getElementById('myForm');
    if (formElement) {
      formElement.scrollIntoView({ behavior: 'smooth' });
      setTimeout(() => {
        const firstNameField = document.getElementById('firstName');
        if (firstNameField) {
          firstNameField.focus();
        }
      }, 300);
    }
  };

  return (
    <>
      <footer>
        <div className="container">
          <div className="row">
            <div className="col-12 mb-3">
              <h4 className="footer-info-text">Personal Loan on Credit Card</h4>
              <p className="footer-info-text">
                <strong>Fixed Rate of interest (on monthly reducing basis):</strong> ROI starting from 13.00%*
              </p>
              <p className="footer-info-text">
                <strong>Tenure:</strong> Minimum 3 months, Maximum 60 months
              </p>
              <p className="footer-info-text">
                <strong>Minimum EMI:</strong> &#8377;455
              </p>
              <p className="footer-info-text">
                <strong>Max APR:</strong> 22.16%*
              </p>
              <p className="footer-info-text">
                <strong>Sample Calculation:</strong><br />
                On a Personal Loan of &#8377;20,000 on your ICICI Bank Credit Card, at a rate of (13%) per annum for a tenure of 60 months, the approximate EMI amount excluding the processing fees will be &#8377;455/-. The loan disbursal is subject to ICICI Bank&#39;s discretion.
              </p>
              <p className="footer-info-text">
                <strong>Address:</strong><br />
                Registered Office: ICICI Bank Tower, Near Chakli Circle, Old Padra Road, Vadodara 390007, Gujarat, India
              </p>
              <p className="footer-info-text">For any further queries, contact our toll-free number - 1800 1080</p>
            </div>
            <div className="col-md-6">
              <p>
                <sup>#</sup>Subject to eligibility
                <br>
                </br>*Terms and Conditions of ICICI Bank apply. For details visit <a href="https://www.icici.bank.in/" rel='noreferrer'
                  target="_blank">www.icici.bank.in</a></p>
            </div>
            <div className="col-md-6">
              <div>
                <p className="text-right">Corporate Office Address: ICICI Bank Towers, Bandra-Kurla Complex, Mumbai 400 051.</p>
              </div>
            </div>
          </div>
        </div>
      </footer>
      {/* Reserves the CTA's height at the end of the page, so at full scroll the
          fixed CTA comes to rest below the footer instead of covering it. */}
      <div className="sticky_apply_now_spacer" style={{ height: `${ctaHeight}px` }} />
      {showButton && (
        <div
          className="footerapplynow"
        >
          <a ref={ctaRef} href="#myForm" onClick={handleCTAClick} className="sticky_apply_now">
            Apply now
          </a>
        </div>
      )}

    </>
  );
}

export default Footer;
